import React from 'react';
import VisitorsComparasion from "./VisitorsComparasion";
import PeakHoursComparasion from "./PeakHoursComparasion";
import AnaluzCustomComparasion from "./AnaluzCustomComparasion";
import DailyAnalyticsComparasion from "./DailyAnalyticsComparasion";
import GenderComparasion from "./GenderComparasion";

const VisitorComparasion = () => {
    return (
        <div className="visitor-comparasion">
            <VisitorsComparasion />
            <PeakHoursComparasion />
            {/*<AnaluzCustomComparasion />*/}
            <DailyAnalyticsComparasion />
            {/*{*/}
            {/*    localStorage.getItem("name") === "Eman Materials"*/}
            {/*        ?*/}

            {/*      <GenderComparasion />*/}
            {/*        :*/}
            {/*        ""*/}
            {/*}*/}
        </div>
    );
};

export default VisitorComparasion;